import type { HttpBackendOptions } from 'i18next-http-backend'
import { API_BASE_URL } from '@/lib/apiBase'

// Strip a trailing `/api` from the base because our terms routes already start at
// `/api/terms`. In dev, API_BASE_URL is `http://localhost:3000/api`; Vite also
// proxies `/api` → :3000, so a relative path works too. We use the absolute base so
// the http-backend behaves the same in dev and prod builds.
const ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '')

export const httpBackendOptions: HttpBackendOptions = {
  // {{lng}} = composite locale code (e.g. en-clinical); {{ns}} = namespace.
  loadPath: `${ORIGIN}/api/terms/{{lng}}/{{ns}}`,
  // POC: no auth / tenant headers (re-add via authHeaders() when the PUT is guarded).
  // crossDomain so the absolute URL is allowed by the http-backend.
  crossDomain: true,
}
